import MeterInput from '@/containers/SubscriptionFormPageNew/Components/GasMeter/Fields/MeterInput/MeterInput'
import MeterConsent from '@/containers/SubscriptionFormPageNew/Components/GasMeter/Fields/MeterConsent'
import MeterInformation from '@/containers/SubscriptionFormPageNew/Components/GasMeter/Fields/MeterInformation'
import useGasMeterListener from '@/containers/SubscriptionFormPageNew/Components/GasMeter/useGasMeterListener'
import PceSearchModal from '@/containers/SubscriptionFormPageNew/Components/GasMeter/PceSearch/PceSearchModal'

// Note: the per-module 'Save' button has been removed. Saving is now driven by
// the global ClientTopHeader button which dispatches CLIENT_TAB_SAVE_ALL.
const GasMeter = () => {
  useGasMeterListener()

  return (
    <>
      <MeterInput />
      <MeterConsent />
      <MeterInformation type='client' />
      <PceSearchModal />
    </>
  )
}

export default GasMeter
